import { IonText } from '@ionic/react';

export const AutoPylotPlus: React.FC = () => (
    <span style={{whiteSpace: 'nowrap'}}>
        <IonText color="primary">AutoPylot+</IonText>
    </span>
);
